/* eslint-disable no-undef */
import React, { Component } from "react";
import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@material-ui/core';
import 'react-tabs/style/react-tabs.css';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { makeStyles } from "@material-ui/core/styles";
import Api from "../../../../../Services/Api";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
var ct = require("../../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable())
const options = { ...ct.customOptions3() };
const optionsSelected = { ...ct.customOptions16() };

class TabDataAccessDatatables extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ? props.data : {
                roleId: ""
            },
            dataRequest: [],
            dataAccessData: [],
        }
    }

    componentDidMount() {
        this.getDataAccess()
    }

    getDataAccess() {
        let payload = {
            roleId: this.state.data.roleId,
        }
        if (this.props.data.accessType === 'Allowed') {
            Api.create('MASTERDATA_EKSAD').postGetRoleDataAllowed(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            item.dataAccess.map((itemAccess) => {
                                if (itemAccess.dataAccess) {
                                    arrayDataRequest.push({
                                        roleId: itemAccess.roleId,
                                        companyId: this.state.data.companyId,
                                        category: itemAccess.category,
                                        dataId: itemAccess.dataId,
                                        accessCompanyId: itemAccess.accessCompanyId,
                                        status: "Active",
                                    })
                                }
                            })
                        })
                        this.setState({
                            dataAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        } else {
            Api.create('MASTERDATA_EKSAD').postGetRoleDataBanned(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            item.dataAccess.map((itemAccess) => {
                                if (itemAccess.dataAccess) {
                                    arrayDataRequest.push({
                                        roleId: itemAccess.roleId,
                                        companyId: this.state.data.companyId,
                                        category: itemAccess.category,
                                        dataId: itemAccess.dataId,
                                        accessCompanyId: itemAccess.accessCompanyId,
                                        status: "Active",
                                    })
                                }
                            })
                        })
                        this.setState({
                            dataAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        }
    }

    setData = (data) => {
        let dataTable = data.map((value) => {
            return [
                "",
                value.data,
            ]
        })
        return dataTable;
    }

    setDataSelected = (data) => {
        let dataTable = data.map((value, index) => {
            return [
                index + 1,
                value.data,
            ]
        })
        return dataTable;
    }

    columns = [
        "",
        "Name",
    ];

    columnsSelected = [
        "No",
        "Name",
    ];

    setCheckAll = (arrays, isChecked, i) => {
        if (arrays[i].searchText) {
            let dataFilter = arrays[i].dataAccess.filter((dataItem) => dataItem.data.toUpperCase().includes(arrays[i].searchText.toUpperCase()));

            arrays[i].dataAccess.map((x) => {
                dataFilter.map((y) => {
                    if (x.dataId === y.dataId) {
                        x.dataAccess = isChecked;
                    }
                });
            });
        } else {
            arrays[i].dataAccess.map((dataLoopAccess) => {
                dataLoopAccess.dataAccess = isChecked
            });
        }

        this.setState({
            dataAccessData: arrays,
        }, () => {
            this.callbackSave();
        })
    }

    callbackSave = () => {
        let payload = [];
        this.state.dataAccessData.map((dataLoopAccessData) => {
            dataLoopAccessData.dataAccess.map((dataLoopAccess) => {
                if (dataLoopAccess.dataAccess) {
                    payload.push(dataLoopAccess);
                }
            });
        });

        this.props.requestData(payload);
    }

    render() {

        return (
            <div>
                {this.state.dataAccessData.map((itemData, i, arrays) => {

                    let arrIdx = [];
                    itemData.dataAccess.map((itemDataSelected, i) => {
                        itemDataSelected.status = "Active";
                        itemDataSelected.searchText = null;

                        if (itemDataSelected.dataAccess) {
                            arrIdx.push(i);
                        }
                    })
                    itemData.selectedRow = arrIdx;

                    let tableOptions = {
                        ...options,
                        serverSide: false,
                        selectableRowsOnClick: true,
                        selectableRows: 'multiple',
                        searchText: itemData.searchText,
                        selectableRowsHeader: false,
                        onSearchChange: (searchText) => {
                            itemData.searchText = (searchText ? searchText : "");
                        },
                        onRowsSelect: (currentRowsSelected, allRowsSelected) => {
                            if (currentRowsSelected.length > 0) {
                                let data = itemData.dataAccess[currentRowsSelected[0].dataIndex];
                                data.dataAccess = !data.dataAccess;
                            }

                            this.callbackSave();
                        },
                        disableToolbarSelect: true,
                        rowsSelected: arrIdx,
                        viewColumns: false,
                    }

                    let tableOptionsSelected = {
                        ...optionsSelected,
                        serverSide: false,
                        search: true,
                        responsive: 'scrollMaxHeight',
                    }

                    return (
                        <div key={i}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>{itemData.companyCode} - {itemData.category}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div style={{ width: '48%' }}>
                                        <div>
                                            <button
                                                style={{ marginBottom: "15px", width: "115px", height: "30px", marginRight: "10px" }}
                                                className="btn btn-red"
                                                type="button"
                                                onClick={() => {
                                                    this.setCheckAll(arrays, true, i);
                                                }}
                                            >
                                                <span>Check All</span>
                                            </button>

                                            <button
                                                style={{ marginBottom: "15px", width: "115px", height: "30px" }}
                                                className="btn btn-red"
                                                type="button"
                                                onClick={() => {
                                                    this.setCheckAll(arrays, false, i);
                                                }}
                                            >
                                                <span>Uncheck All</span>
                                            </button>
                                        </div>
                                        <MuiThemeProvider theme={getMuiTheme()}>
                                            <MUIDataTable
                                                key={i}
                                                subtitle={itemData.category}
                                                data={this.setData(itemData.dataAccess)}
                                                columns={this.columns}
                                                options={tableOptions}
                                            />
                                        </MuiThemeProvider>
                                    </div>
                                    <div style={{ width: '2%' }}></div>
                                    <div style={{ width: '48%', marginTop: "45px" }}>
                                        <MuiThemeProvider theme={getMuiTheme()}>
                                            <MUIDataTable
                                                key={i}
                                                subtitle={"MAPPING " + itemData.category}
                                                data={this.setDataSelected(itemData.dataAccess.filter((data) => data.dataAccess))}
                                                columns={this.columnsSelected}
                                                options={tableOptionsSelected}
                                            />
                                        </MuiThemeProvider>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    )
                })}
            </div>

        )
    }
}

export default TabDataAccessDatatables;